import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
    const navigate = useNavigate();

    return (
        <section id="home" className="hero">
            <div className="hero-overlay"></div>
            <div className="container hero-container">
                <div className="hero-content">
                    <h1>
                        PRECISION CNC <br />
                        MACHINING & <br />
                        ENGINEERING <br />
                        SOLUTIONS
                    </h1>
                    <div className="hero-btns">
                        <button className="btn-white" onClick={() => navigate('/contact')}>Request a Quote</button>
                    </div>
                </div>
            </div>

            {/* Decorative elements - blurred spots */}
            <div className="hero-glow"></div>
        </section>
    );
};

export default Hero;
